
import { useState, useEffect } from 'react';

export function useBackgroundBrightness(backgroundInfo: { url?: string; smallUrl?: string } | null) {
  const [isLight, setIsLight] = useState(false);

  useEffect(() => {
    if (!backgroundInfo) {
      setIsLight(false);
      return;
    }

    const checkBrightness = () => {
      try {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) return false;

        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = backgroundInfo.smallUrl || backgroundInfo.url || '';

        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0, img.width, img.height);

          try {
            const centerX = Math.floor(canvas.width / 2);
            const centerY = Math.floor(canvas.height / 3);
            const sampleSize = 10;
            const imageData = context.getImageData(
              centerX - sampleSize / 2, 
              centerY - sampleSize / 2, 
              sampleSize, 
              sampleSize
            );
            
            let r = 0, g = 0, b = 0;
            for (let i = 0; i < imageData.data.length; i += 4) {
              r += imageData.data[i];
              g += imageData.data[i + 1];
              b += imageData.data[i + 2];
            }
            
            const pixels = imageData.data.length / 4;
            r = Math.floor(r / pixels);
            g = Math.floor(g / pixels);
            b = Math.floor(b / pixels);
            
            const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
            setIsLight(luminance > 186);
          } catch (error) {
            console.error('Error analyzing image data:', error);
            setIsLight(false);
          }
        };
        
        img.onerror = () => {
          setIsLight(false);
        };
      } catch (error) {
        console.error('Error in brightness detection:', error);
        setIsLight(false);
      }
    };
    
    checkBrightness();
  }, [backgroundInfo]);

  return { isLight };
}
